import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import "./css/main.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter as Router } from "react-router-dom";

//Component called by suspense
import Loading from "./components/ui/Loading";

ReactDOM.render(
  <Suspense fallback={<Loading />}>
    <Router>
      <App />
    </Router>
  </Suspense>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
